export class Seat {
    get isDisabled(): boolean {
        return this._isDisabled;
    }

    get isEnabled(): boolean {
        return !this._isDisabled;
    }
    
    public code: string;
    public svgElement: SVGElement;
    public tooltipInfo: string = "";

    public ExtraInfo: any;
    
    private _isDisabled: boolean = false;
    
    
    private _status = SeatStatus.Free;
    private _statusInfo = ""; 


    constructor(svgElement: SVGElement) {
        this.svgElement = svgElement;
        this.code = <string>svgElement.getAttribute("code");
    }

    public AddTooltipInfo(info: string) {
        this.tooltipInfo = info;
    }
    
    public Disable(){
        this._isDisabled = true;
    }
    
    public Enable(){
        this._isDisabled = false
    }
    
    public SetStatus(status: SeatStatus, statusInfo: string = ""){
        this._status = status;
        this._statusInfo = statusInfo;
    }
    
    public HasStatus(status: SeatStatus, statusInfo?: string){
        if (this._status != status) return false;
        if(!statusInfo) return true;
        return this._statusInfo.toLowerCase() === statusInfo.toLowerCase(); 
    }
}

export enum SeatStatus {
    Free,
    Selected,
    Locked,
}